import GlobalStyles from "../../global/GlobalStyles";
import Breadcrumbs from "../../components/others/BreadCrumbs";
import DashboardStatistics from "../../components/dashboardComponents/DashboardStatistics";
import RecentShipments from "../../components/dashboardComponents/RecentShipments";
import PerformanceMetrics from "../../components/dashboardComponents/PerformanceMetrics";

const breadcrumbItems = [{ name: "Dashboard", path: "/admin/dashboard" }];

const DashBoard = () => {
  return (
    <div className={GlobalStyles.dashbooardPageContainer}>
      <div className={GlobalStyles.dashbooardPageWrap}>
        <Breadcrumbs items={breadcrumbItems} />

        <>
          <DashboardStatistics />

          <RecentShipments />

          <PerformanceMetrics />
        </>
      </div>
    </div>
  );
};

export default DashBoard;
